<div *ngIf="loadingService.loading$ | async" class="loading-overlay">
    <div class="spinner"></div>
</div>
<app-header></app-header>

<router-outlet></router-outlet>
